"use client";

import { useEffect } from "react";

export function HomeScrollEffect() {
  useEffect(() => {
    const homePageContentElement = document.getElementById("home-page-content");

    if (!(homePageContentElement instanceof HTMLElement)) {
      return;
    }
    const container: HTMLElement = homePageContentElement;

    let isAnimationFrameQueued = false;

    function updateScrolledClass() {
      const hasScrolled = container.scrollTop > 0;
      container.classList.toggle("scrolled", hasScrolled);
    }

    function onScroll() {
      if (!isAnimationFrameQueued) {
        requestAnimationFrame(() => {
          updateScrolledClass();
          isAnimationFrameQueued = false;
        });
        isAnimationFrameQueued = true;
      }
    }

    // 初始检查
    updateScrolledClass();

    // 监听滚动
    container.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      container.removeEventListener("scroll", onScroll);
    };
  }, []);

  return null;
}
